<template>
        <div :id="id" style="width: 100%" />
</template>

<script>
    import { Chart } from '@antv/g2';


    export default {
        name: "areaChart",
        data(){
            return{
               // data:
                names:"",
                tickCount:5
            }
        },
        props:["data","id" ,"name"],
        watch:{
            data:function(newVal,oldVal){
                this.data = newVal;
                this.changChats(newVal)
              console.log("this.data",this.data)
            },
            id:function(newVal,oldVal){
                this.id = newVal;
                this.changChats(newVal)
              console.log("this.id",this.id)
            },
            name:function (newVal,oldVal) {
                this.name = newVal;
                this.changChats(newVal)
              console.log("this.name",this.name)
            }
        },
        methods:{
            changChats(data){
                this.chart.clear(); // 清理所有
                this.chart.source(data); // 重新加载数据
                // if(data.length==1){
                //     this.chart
                //         .point()
                //         .position('label*value')
                //         .size(2)
                //         .shape('circle')
                //         .style({lineWidth:1})
                // }
                let maxValue = Math.max.apply(Math,this.data.map(item => { return item.value }))
                maxValue <=1 ? this.tickCount = 2 : this.tickCount = 5
                // console.log('maxValue',maxValue);
                // console.log('tickCount',this.tickCount);
                // this.chart.scale({
                //     value: {
                //         tickCount:this.tickCount,
                //         min:0,
                //         range: [0, 1]
                //     },
                //     time: {
                //         min:0,
                //         range: [0, 1],
                //     },
                // });
                this.chart.area().position('time*value');
                this.chart.line().position('time*value');
                this.chart.render();
            },
            newCharts(){
                this.chart = new Chart({
                    container:this.id,
                    autoFit: true,
                    height: 180,
                    padding:[10,40,20,40]
                });

                this.chart.data(this.data);
                // this.chart.scale({
                //     value: {
                //         tickCount:this.tickCount,
                //         range: [0, 1]
                //     },
                //
                //     time: {
                //         range: [0, 1],
                //     },
                // });
                let _that=this

                this.chart.tooltip({showCrosshairs: true,
                        shared: true,
                        itemTpl:`<div style="height: 40px"> <span style="position: relative;"> ${_that.name} : {value} </span></div>`
                });
                this.chart.area().position('time*value');
                this.chart.line().position('time*value');

                // this.chart.render();
            }
        },
        mounted() {
            this.newCharts()
        }
    }
</script>

<style scoped>

</style>
